import { IUserAuthentication } from '../interfaces';

export const USER_01: IUserAuthentication = {
    id: '123123HOIJ',
    token: 'IUHLIUASD98123bn1231',
    accountEnabled: true,
    tradingEnabled: true,
    firstName: 'Demo',
    lastName: 'User',
    userType: 'bank',
};
